// Small object helpers used by mappers and query-param builders.
export const pick = (obj, keys) =>
  keys.reduce((acc, k) => (k in obj ? ((acc[k] = obj[k]), acc) : acc), {});

export const omit = (obj, keys) => {
  const set = new Set(keys);
  return Object.fromEntries(Object.entries(obj).filter(([k]) => !set.has(k)));
};

export const isEmpty = (value) =>
  value == null ||
  (typeof value === 'string' && value.trim() === '') ||
  (Array.isArray(value) && value.length === 0) ||
  (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0);

export const clean = (obj) =>
  Object.fromEntries(Object.entries(obj).filter(([, v]) => !isEmpty(v)));
